import { useLoginOrLogoutVm } from './useLoginOrLogoutVm';

export const LoginOrLogout = () => {
    const { isLogged, toggleLogin } = useLoginOrLogoutVm();

    return <button onClick={toggleLogin}>{!isLogged ? "M'identifier" : 'Me déconnecter'}</button>;
};
